import React from 'react'
import {Card, CardImg, CardBody, CardTitle, CardText, Button} from 'reactstrap'
import * as constants from '../constants'


export default class CompanyForm extends React.Component {
  constructor(props){
    super(props)
    this.state = {edit: false, values: props.company || {}}
  }

  static getDerivedStateFromProps(props, state) {
    if(!state.edit && props.company) {
      return {...state, values: props.company}
    }
    return null
  }

  toggle = (e) => {
    e.preventDefault();
    this.setState({edit: !this.state.edit})
  }

  handleChange = (e) => {
    let value = e.target.type === 'checkbox' ? e.target.checked : e.target.value
    if(value === 'true') value = true
    if(value === 'false') value = false
    const values = {...this.state.values, [e.target.name]: value}
    this.setState({values})
  }

  handleSubmit = (e) => {
    e.preventDefault()
    this.setState({isSubmitting: true})
    this.props.submit({company: this.state.values}).then(() =>
      this.setState({edit:false, isSubmitting:false})
    ).catch(error => this.setState({isSubmitting: false}))
  }

  handleLogoChange = (e) => {
    if(!e.target.files || e.target.files.length===0) return

    const reader = new FileReader();
    this.setState({isUploadingLogo: true})

    reader.addEventListener("load", () => {
      const values = {...this.state.values, logo: reader.result}
      this.setState({values, isUploadingLogo: false})
    }, false);

    reader.readAsDataURL(e.target.files[0]);
  }

  render(){
    return(
      <form onSubmit={this.handleSubmit}>
        <Card className="m-b-20">
          <CardBody>
            <CardTitle>
              Angaben zum Unternehmen{' '}
              <a href="#" onClick={this.toggle} className="float-right">
                {!this.state.edit
                  ?
                  <i className="fas fa-pencil-alt"/>
                  :
                  <i className="fas fa-window-close"/>
                }
              </a>
            </CardTitle>
            <CardText tag="div">
              <div className="form-group row">
                <label htmlFor="logo" className="col-sm-3 col-form-label">Logo</label>
                {this.state.edit
                  ?
                  <React.Fragment>
                    <div className="col-sm-2">
                      <img style={{width: '50px'}} src={this.state.values.logo}/>
                    </div>
                    <div className="col-sm-7">
                      <input
                        type="file"
                        name="logo"
                        className='form-control-file'
                        id='logo'
                        onChange={this.handleLogoChange}/>
                    </div>
                  </React.Fragment>
                  :
                  <div className="col-sm-9">
                    <img style={{width: '100px'}} src={this.state.values.logo}/>
                  </div>
                }
              </div>

              {this.props.company && constants.COMPANY_KEYS.map(key =>
                <div className="form-group row" key={key}>
                  <label
                    htmlFor={key}
                    className="col-sm-3 col-form-label">
                    {key.replace(/\b\w/g, l => l.toUpperCase())}
                  </label>
                  <div className="col-sm-9">
                    <input
                      type="text"
                      name={key}
                      readOnly={!this.state.edit}
                      className={`form-control${!this.state.edit ? '-plaintext' : ''}`}
                      id={key}
                      onChange={this.handleChange}
                      value={this.state.values[key] || ''}
                      placeholder={this.state.values[key]}/>
                  </div>
                </div>
              )}
            </CardText>
            {this.state.edit &&
              <React.Fragment>
                <Button color='primary' disabled={this.state.isSubmitting}>
                  {this.state.isSubmitting ? 'Bitte warten...' : 'Übernehmen'}
                </Button>{' '}
                <Button color="secondary" onClick={this.toggle}>Abbrechen</Button>
              </React.Fragment>
            }
          </CardBody>
        </Card>
      </form>
    )
  }
}



// WEBPACK FOOTER //
// /Users/d064310/Development/playland/colorribbon/src/components/CompanyForm.js